export const UNASSIGNED_APPROVER_LABEL = "Unassigned";

export enum GpConclusionValue {
  ApprovedNextQuarter = "approved_next_quarter",
  ApprovedCurrentQuarter = "approved_current_quarter",
  // Bare approve without an invoicing resolution — secondary (CSM Manager) leg only;
  // the invoicing-period call belongs to the GP Billing Admin (primary) leg.
  Approved = "approved",
  Invalid = "invalid",
}

type GpConclusionOption = { value: GpConclusionValue; label: string };

const INVALID_OPTION: GpConclusionOption = {
  value: GpConclusionValue.Invalid,
  label: "Invalid",
};

export const GP_PRIMARY_CONCLUSION_OPTIONS: ReadonlyArray<GpConclusionOption> = [
  {
    value: GpConclusionValue.ApprovedNextQuarter,
    label: "Approved – Apply to next quarter's invoice",
  },
  {
    value: GpConclusionValue.ApprovedCurrentQuarter,
    label: "Approved – Apply to current quarter's invoice",
  },
  INVALID_OPTION,
];

export const GP_SECONDARY_CONCLUSION_OPTIONS: ReadonlyArray<GpConclusionOption> = [
  {
    value: GpConclusionValue.Approved,
    label: "Approved",
  },
  INVALID_OPTION,
];
